import { createFileRoute, Outlet } from '@tanstack/react-router';
import Footer from '@/components/Footer';
import Navbar from '@/components/Navbar';

export const Route = createFileRoute('/brands')({
  component: BrandsLayout,
});

function BrandsLayout() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
}
